if (!customElements.get('clothing-size-guide')) {
  customElements.define('clothing-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const activate = (tab) => {
        tabs.forEach(button => {
          const selected = button === tab;
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
          button.style.background = selected ? '#dfe7f2' : 'transparent';
        });
        this.querySelectorAll('[role="tabpanel"]').forEach(panel => {
          panel.hidden = panel.dataset.panel !== tab.dataset.chart;
          const inactive = panel.dataset.panel !== tab.dataset.chart;
          panel.style.visibility = inactive ? 'hidden' : 'visible';
          panel.inert = inactive;
          panel.setAttribute('aria-hidden', String(inactive));
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); activate(next); next.focus(); }
        });
      });
    }
  });
}